// extracted by mini-css-extract-plugin
module.exports = {"locationsForm":"LocationsTable_locationsForm__3rmnS","submitButton":"LocationsTable_submitButton__3Loy_"};